import { createContext, useContext } from "react";
import type { AttemptStatus } from "./AttemptController";
import type {
  ChildControls,
  ParentCapability,
  ParentPinRecord,
  ParentStorageState,
  StudioToolLevel,
  UnlockResult,
} from "./parentTypes";

export interface ParentModeContextValue {
  storageState: ParentStorageState;
  controls: ChildControls;
  isConfigured: boolean;
  isCorrupt: boolean;
  isUnlocked: boolean;
  toolLevel: StudioToolLevel;
  notice: string;
  clearNotice: () => void;
  askParent: (message?: string) => void;
  can: (capability: ParentCapability) => boolean;
  getAttemptStatus: () => AttemptStatus;
  unlock: (pin: string) => Promise<UnlockResult>;
  lock: () => void;
  saveInitialConfiguration: (pin: ParentPinRecord, controls: ChildControls) => void;
  saveControls: (controls: ChildControls) => void;
  saveChangedPin: (pin: ParentPinRecord) => void;
  resetConfiguration: (confirmation: string) => void;
}

export const ParentModeContext = createContext<ParentModeContextValue | null>(null);

export function useParentMode(): ParentModeContextValue {
  const context = useContext(ParentModeContext);
  if (!context) throw new Error("Parent Mode must be used within ParentModeProvider.");
  return context;
}
